import * as React from "react";
import { fillColor } from "./FlowPreviewBackground";

export const FlowPreviewBackgroundMobile = () => (
  <svg
    width="295"
    height="155"
    viewBox="0 0 295 155"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.1"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M126.98 247.421C87.6432 243.957 71.9694 213.859 40.0591 198.561C4.6623 181.591 -57.5564 184.589 -66.8251 154.507C-76.1316 124.302 -26.2996 99.8147 1.55766 73.6033C30.9144 45.981 50.2655 0.146309 97.2689 0.107875C145.342 0.0685586 146.684 51.5025 180.821 73.4567C209.12 91.6556 259.476 89.6704 275.241 114.564C295.551 146.633 306.125 189.434 273.044 219.078C239.931 248.751 177.458 251.867 126.98 247.421Z"
      fill={fillColor}
    />
  </svg>
);
